import createReactComponent from '../createReactComponent';
export default createReactComponent('fence-off', 'IconFenceOff', [
  ['path', { d: 'M12 12h-8v4h12m4 0v-4h-4', key: 'svg-0' }],
  ['path', { d: 'M6 16v4h4v-4', key: 'svg-1' }],
  ['path', { d: 'M10 12v-2m0 -4l-2 -2m-2 2v6', key: 'svg-2' }],
  ['path', { d: 'M14 16v4h4v-2', key: 'svg-3' }],
  ['path', { d: 'M18 12v-6l-2 -2l-2 2v4', key: 'svg-4' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-5' }],
]);
